export default __webpack_public_path__ + "static/media/ddt.5c70978c.svg";